import { takeEvery, put, call } from "redux-saga/effects"
import { toast } from "react-toastify";
// Login Redux States
import { ADD_BUILDER, ADD_BUILDER_DEPART, DELETE_BUILDER, GET_BUILDER, GET_BUILDER_DETAIL, GET_BUILDER_PROJECT, UPDATE_BUILDER } from "./actionTypes"
import { addSuccess,  builderapiError, getBuildersSuccess, getBuildersFail,getBuilderDetailFail, addDepartSuccess, apiDepartError, getBuilderDetailSuccess, deleteBuilderSuccess, deleteBuilderFail, getBuilderProjectSuccess, getBuilderProjectFail, updateBuilderError, updateBuilderSuccess } from "./actions"

import { postBuilder, getBuilderdata, getBuilderDetail, deleteBuilderDetailApi, getBuilderProjectApi, updatetBuilderApi} from "../../helpers/backend_helper"

function* addBuilders({ payload: { builder, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(postBuilder, {
      builderName: builder.builderName,
      builderLogo: builder.builderLogo,
      fullAddress: builder.fullAddress,
      addressLine1: builder.addressLine1,
      addressLine2: builder.addressLine2,
      bAddressId: 0,
      city: builder.city,
      province: builder.province,
      postal: builder.postal,
      country: builder.country,
      bIsActive: true,
      agentId: parseInt(localStorage.getItem("userId")),
      builderLogoImage: null,
      builderLogoImageContent: null,
    });
    yield put(addSuccess(response));
    if(response.success){
    const res = yield call(getBuilderdata, localStorage.getItem("userId"));
    yield put(getBuildersSuccess(res));
        toast.update(toastId, {
          render: "Saved successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });

    if (callback) callback(true);
    }else{
       toast.update(toastId, {
          render: response.validationErrors?.[0] || "Some issue!",
          type: "warning",
          isLoading: false,
          autoClose: 3000,
        });
         if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: "Something went wrong. Please try again.",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
  if (callback) callback(false);
    yield put(builderapiError("Some Error"));
  }
}

function* fetchBuilders({agentId}) {
  try {
    const response = yield call(getBuilderdata,agentId)
    yield put(getBuildersSuccess(response))
    
  } catch (error) {
    yield put(getBuildersFail(error))
  }
}

function* fetchBuilderDetail({ builderId }) {
  try {
    const response = yield call(getBuilderDetail, builderId)
    //
    yield put(getBuilderDetailSuccess(response))
  } catch (error) {
    yield put(getBuilderDetailFail(error))
  }
}


function* addDeparts({ payload: { depart, history } }) {
  
  try {
    toast.loading("Please wait...")
      const response = yield call(postDepart, {
        builderId: depart.builderId,
        bContactDepartment: depart.bContactDepartment,
        phone: depart.phone,
        phoneExt: depart.phoneext,
        email: depart.email,
        mobile: depart.mobile,
        fax: depart.fax
           
      })
    yield put(addDepartSuccess(response))
       
    }
catch (error) {
  yield put(apiDepartError('Some Error'))
}
}


function* onDeleteBuilder({ payload: builder }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteBuilderDetailApi, builder.id)
    yield put(deleteBuilderSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getBuilderdata, builder.agentId)
    yield put(getBuildersSuccess(res))

  } catch (error) {
    yield put(deleteBuilderFail(error))
  }
}

function* fetchBuilderProject({ payload : {builderId, agentId}}) {
  try {
    const response = yield call(getBuilderProjectApi,builderId, agentId)
    yield put(getBuilderProjectSuccess(response))
    
  } catch (error) {
    yield put(getBuilderProjectFail(error))
  }
}

function* onUpdateBuilders({ payload: {builder, callback} }) {
  
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updatetBuilderApi, builder);
    yield put(updateBuilderSuccess(response));
    if(response.success){
    const res = yield call(getBuilderdata, localStorage.getItem('userId'));
     yield put(getBuildersSuccess(res));
    toast.update(toastId, {
      render: "Updated successfully.",
      type: "success",
      isLoading: false,
      autoClose: 3000,
      closeOnClick: true
    });
   
    if (callback) callback(true);
    }else{
       toast.update(toastId, {
      render: response.validationErrors?.[0] || "Some issue!",
      type: "warning",
      isLoading: false,
      autoClose: 3000,
      closeOnClick: true
    });
     if (callback) callback(false);
    }
  } catch (error) {
    if (toastId) {
      toast.update(toastId, {
        render: "Failed to update builder",
        type: "error",
        isLoading: false,
        autoClose: 3000
      });
    }
     if (callback) callback(false);
    yield put(updateBuilderError(error));
  }
}
function* builderSaga() {
  yield takeEvery(ADD_BUILDER, addBuilders)
  yield takeEvery(GET_BUILDER, fetchBuilders)
  yield takeEvery(GET_BUILDER_DETAIL, fetchBuilderDetail)
  yield takeEvery(ADD_BUILDER_DEPART, addDeparts)
  yield takeEvery(DELETE_BUILDER, onDeleteBuilder)
  yield takeEvery(GET_BUILDER_PROJECT, fetchBuilderProject)
  yield takeEvery(UPDATE_BUILDER, onUpdateBuilders)
}

export default builderSaga
